import {
    Component,
    Input,
    Renderer2,
    HostListener,
    OnInit,
    ElementRef,
    AfterContentInit,
    TemplateRef,
    ContentChild,
    OnChanges,
    SimpleChanges,
    ViewEncapsulation,
    ViewChild
} from '@angular/core';

import { filter, Subscription } from 'rxjs';

import { ScrollBarService } from '../scroll-bar/scroll-bar.service';

@Component({
    templateUrl: './scrolled-list.component.html',
    selector: 'tk-scrolled-list',
    styleUrls: ['./scrolled-list.component.less'],
    encapsulation: ViewEncapsulation.None
})
export class ScrolledListComponent implements OnInit, OnChanges, AfterContentInit {

    public visibleItems: Array<any> = [];

    @Input() id: string = '';

    @Input()
    public items!: Array<any>;

    @Input()
    public styleClass: string = '';

    @Input()
    public itemHeight: number = 0;

    @Input()
    public autoSort = true;

    @ContentChild('itemTemplate')
    public itemTemp!: TemplateRef<any>;


    private scrollDeltaSub: Subscription;

    private parentHeight = 0;

    private parentWidth = 0;

    private parentFullHeight = 0;

    private offsetHeight = 0;

    currentStartIndex = 0;

    parentMarginTop = 0;

    private itemsCount = 0;

    private moveRation = 0;

    public isScrolling = false;

    public scrollOffset = 0;


    @Input()
    public areaWidth = 0;

    @Input()
    public areaHeight?: number;

    @Input()
    public selectedId: any;

    @Input()
    public idFieldName?: string;

    @Input()
    public sortFieldName?: string;

    private sortedItems = [];


    private showElements() {
        if (this.items && this.sortedItems.length > 0) {
            const _visibleItems: any[] = [];
            let s = this.currentStartIndex;
            let e = this.currentStartIndex + this.itemsCount;

            if (e >= this.sortedItems.length - 1) {
                e = this.sortedItems.length - 1;
                s = e - this.itemsCount;
                if (s < 0) {
                    s = 0;
                }
            }

            for (let i = s; i <= e; i++) {
                const el = this.sortedItems[i];
                if (el) {
                    _visibleItems.push(el);
                }
            }

            let _parentMarginTop = (_visibleItems.length * this.itemHeight!) - this.parentHeight!;
            if (this.sortedItems.length <= this.itemsCount) {
                _parentMarginTop = 0;
            } else if (this.currentStartIndex === 0) {
                _parentMarginTop = 0;
            }
            this.parentMarginTop = _parentMarginTop;



            this.visibleItems = _visibleItems;

        }
    }

    private processScroll(step: number) {

        // jak miescie sie na jednym ekranie
        if (this.sortedItems.length < this.itemsCount) {
            return;
        }

        const sensitivity = 1;

        // przeliczenie zmiany
        // deltaY
        // jak delta za szybko to skaczemy pagami
        const sign = Math.sign(step);
        let deltaY = Math.floor(Math.abs(step) / sensitivity);
        if (deltaY > this.itemsCount) {
            deltaY = this.itemsCount;
        }

        const move = (deltaY * this.moveRation);

        if (sign < 0) {
            this.scrollDown(move);
        } else {
            this.scrollUp(move);
        }
    }

    @HostListener('window:resize', ['$event'])
    public onWindowResize(evt: any) {
        // rekalkulacja
        this.parentHeight = this.$element.nativeElement.offsetParent.clientHeight;
        this.parentWidth = this.$element.nativeElement.offsetParent.clientWidth;
        this.itemsCount = Math.floor(this.parentHeight / this.itemHeight!);
        this.showElements();
        this.showScrollBar(0);
        this.scrollOffset = this.parentWidth - this.areaWidth;

        // konfiguracja scroll
        this.$scrollBar.setOptions({ elementId: this.id, factor: (this.parentHeight / this.parentFullHeight) });
    }

    @HostListener('wheel', ['$event'])
    public onWheel($event: any) {
        if (Math.abs($event.deltaX) < 50) {
            $event.preventDefault();
            $event.stopPropagation();
            this.processScroll($event.deltaY);
            return;
        }
    }

    ngOnInit() {
        this.showElements();
        this.showScrollBar(0);
    }


    ngOnChanges(changes: SimpleChanges) {


        let resultChange = true;

        this.parentHeight = this.$element.nativeElement.offsetParent.clientHeight;
        this.parentWidth = this.$element.nativeElement.offsetParent.clientWidth;


        if (changes && changes['itemHeight']) {
            this.itemsCount = Math.floor(this.parentHeight / this.itemHeight!);
        }
        if (changes && changes['areaHeight']) {
            this.itemsCount = Math.floor(this.parentHeight / this.itemHeight!);
        }

        if (!(changes && changes['areaHeight'])) {
            this.areaHeight = this.$element.nativeElement.offsetParent.clientHeight;
        }
        if (!(changes && changes['areaWidth'])) {
            this.areaWidth = this.$element.nativeElement.offsetParent.clientWidth;
        }

        // find selected item and move start index
        if (this.items && this.itemHeight) {

            // wskaznik zmiany
            this.parentFullHeight = this.items.length * this.itemHeight;
            this.moveRation = Math.ceil(this.parentFullHeight / this.parentHeight);
            if (this.moveRation < this.itemHeight) {
                this.moveRation = Math.ceil(this.itemHeight / 2);
            }

            // konfiguracja scroll
            this.$scrollBar.setOptions({ elementId: this.id, factor: (this.parentHeight / this.parentFullHeight) });


            if (changes['selectedId'] && changes['selectedId'].currentValue === null) {
            } else {
                // jezeli result set się zmienił w sensie tylko przesortowany to nie resetujemy pozycji
                if (changes['items'] && changes['items'].currentValue && changes['items'].previousValue) {


                    const prev = changes['items'].previousValue.map((i: any) => i[this.idFieldName!]);
                    const next = changes['items'].currentValue.map((i: any) => i[this.idFieldName!]);
                    if (this.isTheSame(prev, next) === true) {
                        resultChange = false;
                    } else {
                        this.offsetHeight = 0;
                        this.currentStartIndex = 0;
                        this.parentMarginTop = 0;
                    }
                } else {
                    if (changes['selectedId'] && !changes['selectedId'].firstChange) {
                        // resultChange = false;
                    } else {

                    }
                }
            }

            if (resultChange) {
                const sortField = this.sortFieldName || this.idFieldName;
                if (sortField && this.autoSort === true) {
                    if (this.sortFieldName === '$index') {
                        this.sortedItems = JSON.parse(JSON.stringify(this.items));
                    } else {
                        const _sorted = this.items.sort((a, b) => a[sortField] - b[sortField]);
                        this.sortedItems = JSON.parse(JSON.stringify(_sorted));
                    }
                } else {

                    this.sortedItems = JSON.parse(JSON.stringify(this.items));
                }
            } else {
                this.sortedItems = JSON.parse(JSON.stringify(this.items));

            }


            if (changes && changes['selectedId'] && changes['selectedId'].currentValue !== changes['selectedId'].previousValue) {
                if (this.selectedId && this.itemsCount && this.idFieldName) {
                    let _currentStartIndex = this.sortedItems.findIndex(i => i[this.idFieldName!] === this.selectedId);

                    if (_currentStartIndex !== -1) {

                        // jezeli ten kurent index zawiera sie na stronie ktora jest obecnie to nic nie robimu
                        if (this.currentStartIndex <= _currentStartIndex && _currentStartIndex < this.currentStartIndex + this.itemsCount) {
                            _currentStartIndex = this.currentStartIndex;
                        }
                        // jezeli to jest na ostatniej stronie to nalezy dociagnac do konca
                        else if (_currentStartIndex + this.itemsCount >= this.sortedItems.length) {
                            _currentStartIndex = this.sortedItems.length - this.itemsCount;
                        }
                        else {
                            _currentStartIndex--;
                        }

                        this.currentStartIndex = _currentStartIndex;
                        this.offsetHeight = this.itemHeight * this.currentStartIndex;
                    } else {
                        this.offsetHeight = 0;
                        this.currentStartIndex = 0;
                        this.parentMarginTop = 0;
                    }

                }

            }
        }

        // pokazanie elementow
        if (changes) {

            if (changes['selectedId'] && changes['selectedId'].currentValue === null) {

            } else {
                this.showElements();
                this.showScrollBar(0);
                this.scrollOffset = this.parentWidth - this.areaWidth;
            }
        }

    }

    private isTheSame(prev: number[], next: number[]): boolean {

        prev.sort((x, y) => x - y);
        next.sort((x, y) => x - y);

        let i = 0;
        let j = 0;
        const joined: number[] = [];

        while (i < prev.length && j < next.length) {

            if (prev[i] === next[j]) {
                joined.push(prev[i]);
                i += 1;
                j += 1;
            } else if (prev[i] < next[j]) {
                i += 1;
            } else {
                j += 1;
            }

        }

        let flag = (joined.length === prev.length) && (prev.length === next.length);

        if (flag === true) {
            for (i = joined.length - 1; i >= 0; i--) {
                if (prev[i] !== next[i]) {
                    flag = false;
                    break;
                }
            }
        }

        return flag;
    }

    private showScrollBar(move: number) {


        const scale = (this.parentHeight / this.items!.length);
        const sign = Math.sign(move);

        const delta = { elementId: this.id, delta: Math.ceil(scale * (this.currentStartIndex)) };
        this.$scrollBar.setDelta(delta);

    }

    scrollUp(move: number) {
        if (this.currentStartIndex + this.itemsCount <= this.sortedItems.length - 1) {

            this.parentMarginTop += move;
            if (this.parentMarginTop >= this.itemHeight!) {
                this.parentMarginTop = 0;
                this.currentStartIndex++;
            }

            this.showElements();

        } else {

        }
        this.showScrollBar(move);
    }


    scrollDown(move: number) {
        if (this.currentStartIndex >= 0) {

            this.parentMarginTop -= move;
            if (this.parentMarginTop <= 0 && this.currentStartIndex > 0) {
                this.parentMarginTop = this.itemHeight!;
                this.currentStartIndex--;
            }
            if (this.currentStartIndex < 0) {
                this.currentStartIndex = 0;
            }
            if (this.currentStartIndex === 0 && this.parentMarginTop < 0) {
                this.parentMarginTop = 0;
            }
            this.showElements();

            this.showScrollBar(-move);
        }
    }

    ngAfterContentInit() {
        // konfiguracja scroll
        this.$scrollBar.setOptions({ elementId: this.id, factor: (this.parentHeight / this.parentFullHeight) });

    }

    constructor(
        private $renderer: Renderer2,
        private $element: ElementRef,
        private $scrollBar: ScrollBarService
    ) {
        this.scrollDeltaSub = this.$scrollBar.getScrollDelta().pipe(filter(delta => delta && delta.elementId === this.id))
            .subscribe(delta => {
                if (delta) {
                    this.currentStartIndex = Math.floor(delta.position / this.itemHeight!);
                    const diff = delta.position - this.currentStartIndex * this.itemHeight!;
                    this.parentMarginTop = diff;
                    this.showElements();
                }
            });
    }

}
